namespace Nobox.Membership {

    @Serenity.Decorators.registerClass()
    export class SignUpPanel extends Serenity.PropertyPanel<SignUpRequest, any> {

        protected getFormKey() { return SignUpForm.formKey; }
        protected form = new SignUpForm(this.idPrefix);

        constructor(container: JQuery) {
            super(container);

            var $form = this.form;
            var toStep = 1;
            Serenity.EditorUtils.setValue($form.Opt, "1");
            this.form.Opt.element.on('change', function () {
                if ($form.Opt.value == '1') {
                    $form.InvCd.getGridField().toggle(true);

                    $form.TnNm.getGridField().toggle(false);
                    $form.TnIdtry.getGridField().toggle(false);
                    $form.TnSize.getGridField().toggle(false);
                } else if ($form.Opt.value == '2') {
                    $form.InvCd.getGridField().toggle(false);
                    $form.InvCd.value = "";

                    $form.TnNm.getGridField().toggle(true);
                    $form.TnIdtry.getGridField().toggle(true);
                    $form.TnSize.getGridField().toggle(true);
                }
            });
            this.form.ConfirmPassword.addValidationRule(this.uniqueName, e => {
                if (this.form.ConfirmPassword.value !== this.form.Password.value) {
                    return Q.text('Validation.PasswordConfirm');
                }
            });
            var $this = this;
            this.byId('Back').click(e => {
                e.preventDefault();
                if (toStep == 3) {
                    toStep = 2;
                    $form.Recaptcha.getGridField().toggle(false);
                    $form.Opt.getGridField().toggle(false);
                    $form.InvCd.getGridField().toggle(false);
                    $form.TnNm.getGridField().toggle(false);
                    $form.TnIdtry.getGridField().toggle(false);
                    $form.TnSize.getGridField().toggle(false);

                    $form.CtryId.getGridField().toggle(true);
                    $form.StatesId.getGridField().toggle(true);
                    $form.CityId.getGridField().toggle(true);
                    $form.MobilePhoneNumber.getGridField().toggle(true);
                    $this.byId('Back').removeClass("disabled");
                    $this.byId('SubmitButton').html('<span class="txt">Next</span> <i class="fa fa-chevron-right"></i>');
                    $this.byId('Title').text("Enter your details Profile Account.");
                    return;
                }
                if (toStep == 2) {
                    toStep = 1;
                    $this.byId('Back').addClass("disabled");
                    $this.byId('SubmitButton').html('<span class="txt">Next</span> <i class="fa fa-chevron-right"></i>');
                    $this.byId('Title').text("Enter your details to create a free Account.");
                    $form.DisplayName.getGridField().toggle(true);
                    $form.Email.getGridField().toggle(true);
                    //$form.ConfirmEmail.getGridField().toggle(true);
                    $form.Password.getGridField().toggle(true);
                    $form.ConfirmPassword.getGridField().toggle(true);

                    $form.CtryId.getGridField().toggle(false);
                    $form.StatesId.getGridField().toggle(false);
                    $form.CityId.getGridField().toggle(false);
                    $form.MobilePhoneNumber.getGridField().toggle(false);
                    return;
                }
                if (toStep == 4) {
                    toStep = 1;
                    $form.Recaptcha.getGridField().toggle(false);
                    $this.byId('Back').addClass("disabled");
                    $this.byId('SubmitButton').html('<span class="txt">Next</span> <i class="fa fa-chevron-right"></i>');
                    $this.byId('Title').text("Enter your details to create a free Account.");
                    $form.DisplayName.getGridField().toggle(true);
                    $form.Email.getGridField().toggle(true);
                    //$form.ConfirmEmail.getGridField().toggle(true);
                    $form.Password.getGridField().toggle(true);
                    $form.ConfirmPassword.getGridField().toggle(true);

                    $form.CtryId.getGridField().toggle(false);
                    $form.StatesId.getGridField().toggle(false);
                    $form.CityId.getGridField().toggle(false);
                    $form.MobilePhoneNumber.getGridField().toggle(false)
                    return;
                }
            });
            this.byId('SubmitButton').click(e => {
                e.preventDefault();

                if (!this.validateForm()) {
                    return;
                }
                if (toStep == 1) {
                    toStep = 2;
                    $form.DisplayName.getGridField().toggle(false);
                    $form.Email.getGridField().toggle(false);
                    //$form.ConfirmEmail.getGridField().toggle(false);
                    $form.Password.getGridField().toggle(false);
                    $form.ConfirmPassword.getGridField().toggle(false);

                    $form.MobilePhoneNumber.getGridField().toggle(true);
                    $form.CtryId.getGridField().toggle(true);
                    $form.StatesId.getGridField().toggle(true);
                    $form.CityId.getGridField().toggle(true);
                    $form.Recaptcha.getGridField().toggle(false);
                    $this.byId('Back').removeClass("disabled");
                    $this.byId('Title').text("Enter your details Profile Account.");
                    if (window.location.pathname.match("/Invite/Users/")) {
                        $this.byId('SubmitButton').html("SignUp");

                        $form.Recaptcha.getGridField().toggle(true);
                        toStep = 4;
                        $this.form.InvCd.value = window.location.pathname.replace("/Invite/Users/","");
                    }
                    return;
                }
                if (toStep == 2) {
                    toStep = 3;
                    $form.CtryId.getGridField().toggle(false);
                    $form.StatesId.getGridField().toggle(false);
                    $form.CityId.getGridField().toggle(false);
                    $form.MobilePhoneNumber.getGridField().toggle(false);

                    $form.Opt.getGridField().toggle(true);

                    $form.Recaptcha.getGridField().toggle(true);
                    $this.byId('SubmitButton').html("SignUp");
                    $this.byId('Title').text("Create or join tenant.");
                    if ($form.Opt.value == '1') {
                        $form.InvCd.getGridField().toggle(true);

                        $form.TnNm.getGridField().toggle(false);
                        $form.TnIdtry.getGridField().toggle(false);
                        $form.TnSize.getGridField().toggle(false);
                    } else if ($form.Opt.value == '2') {
                        $form.InvCd.getGridField().toggle(false);

                        $form.TnNm.getGridField().toggle(true);
                        $form.TnIdtry.getGridField().toggle(true);
                        $form.TnSize.getGridField().toggle(true);
                    }
                    return;
                }
                if (toStep == 3) {
                    Q.serviceCall({
                        url: Q.resolveUrl('~/Account/SignUp'),
                        request: {
                            DisplayName: this.form.DisplayName.value,
                            Email: this.form.Email.value,
                            Password: this.form.Password.value,
                            InvCd: this.form.InvCd.value,
                            CityId: this.form.CityId.value,
                            CtryId: this.form.CtryId.value,
                            StatesId: this.form.StatesId.value,
                            MobilePhoneNumber: this.form.MobilePhoneNumber.value,
                            TnNm: this.form.TnNm.value,
                            TnSize: this.form.TnSize.value,
                            TnIdtry: this.form.TnIdtry.value,
                            Opt: this.form.Opt.value,
                            Recaptcha: this.form.Recaptcha.get_value()
                        },
                        onSuccess: response => {
                            Q.information(Q.text('Forms.Membership.SignUp.Success'), () => {
                                window.location.href = Q.resolveUrl('~/');
                            });
                        },
                        onError: (err: Serenity.ServiceResponse) => {
                            grecaptcha.reset();
                            Q.ErrorHandling.showServiceError(err.Error);
                        }
                    });
                }
                if (toStep == 4) {
                    if (this.form.TnIdtry.value != null) {
                        this.form.TnIdtryNm.value = this.form.TnIdtry.text;
                    }
                    if (this.form.TnSize.value != null) {
                        this.form.TnSizeNm.value = this.form.TnSize.text;
                    }
                    Q.serviceCall({
                        url: Q.resolveUrl('~/Account/SignUp'),
                        request: {
                            DisplayName: this.form.DisplayName.value,
                            Email: this.form.Email.value,
                            Password: this.form.Password.value,
                            InvCd: this.form.InvCd.value,
                            CityId: this.form.CityId.value,
                            CtryId: this.form.CtryId.value,
                            StatesId: this.form.StatesId.value,
                            MobilePhoneNumber: this.form.MobilePhoneNumber.value,
                            TnNm: this.form.TnNm.value,
                            TnSize: this.form.TnSize.value,
                            TnIdtry: this.form.TnIdtry.value,
                            Opt: this.form.Opt.value,
                            TnIdtryNm: this.form.TnIdtryNm.value,
                            TnSizeNm: this.form.TnSizeNm.value,
                            Recaptcha: this.form.Recaptcha.get_value()
                        },
                        onSuccess: response => {
                            Q.information(Q.text('Forms.Membership.SignUp.Success'), () => {
                                window.location.href = Q.resolveUrl('~/');
                            });
                        },
                        onError: (err: Serenity.ServiceResponse) => {
                            grecaptcha.reset();
                            Q.ErrorHandling.showServiceError(err.Error);
                        }
                    });
                }

            });
            var def = JSON.parse($("#ScriptDefault").text());
            $form.CtryId.set_value(def.Country)
            $form.MobilePhoneNumber.value = def.CountryCode;
        }
    }

    export enum SignUpSteps {
        Account = 1,
        Profile = 2,
        Tenant = 3
    }
}